/* istanbul ignore file: Directive */
'use strict';

customerZone.directive('lightToFullBlocked', function(){
    return {
        restrict: 'E',
        scope: {
            subject: '='
        },
        template: '<div class="alternative-em-block">' +
        '<p ng-bind-html="\'during_light_to_full_migration_\'+subject+\'_blocked\' | translate"></p></div>'
    };
});
